// src/modules/loadTranslations.js
// Shared module for loading and caching brand translations


import apiProxy from '../services/apiProxy';
const localforage = require('localforage');
const store = localforage.createInstance({ name: 'tranlations' });

/**
 * Loads translations for a given brand and language, with session and local overrides.
 * @param {string} brandId - Brand slug
 * @param {string} [lang] - Language code (optional, will auto-detect)
 * @returns {Promise<Object>} - Resolves to translations object
 */
export async function loadTranslations(brandId, lang) {
  // Detect language from sessionStorage, URL param, or fallback
  let detectedLang = lang;
  if (!detectedLang) {
    detectedLang = sessionStorage.getItem('language');
    if (!detectedLang) {
      // Example: fallback logic for default language per brand
      if (process.env.VUE_APP_DEFAULT_LANG_DE &&
          JSON.parse(process.env.VUE_APP_DEFAULT_LANG_DE).includes(brandId)) {
        detectedLang = 'de';
      } else {
        detectedLang = 'en';
      }
      sessionStorage.setItem('language', detectedLang);
    }
    // Check URL param
    const urlParams = new URLSearchParams(window.location.search);
    const paramLang = urlParams.get('lang');
    if (paramLang) {

      // remove quoutes if present
      const cleanedLang = paramLang.replace(/^["']|["']$/g, '');
      // update with cleaned value param lang
      //urlParams.set('lang', cleanedLang);

      detectedLang = cleanedLang;
      sessionStorage.setItem('language', detectedLang);
    }
  }

  // Try to load from local storage cache first
  let translations = null;
  try {
    const cached = await store.getItem('tranlations');
    if (cached) {
      translations = JSON.parse(cached);
      return translations;
    }
  } catch (e) {
    // Ignore cache errors
  }

  // Fetch from API if not cached
  try {
    const response = await apiProxy.call('brand_translations', { brandslug: brandId });
    translations = response;
    await store.setItem('tranlations', JSON.stringify(translations));
    return translations;
  } catch (e) {
    // Fallback: return empty object if API fails
    return {};
  }
}
